import { render, staticRenderFns } from "./transferDetail.vue?vue&type=template&id=00af498b&"
import script from "./transferDetail.vue?vue&type=script&lang=js&"
export * from "./transferDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports